import { isFuture } from "./isFuture.js";
import { isPast } from "./isPast.js";
import toDate from "./toDate.js";
const getLiveState = (startDate, endDate)=>{
    const start = 'string' == typeof startDate ? toDate(startDate) : startDate;
    const end = 'string' == typeof endDate ? toDate(endDate) : endDate;
    if (end && isPast(end)) return 'past';
    if (start && isPast(start) && (!end || isFuture(end))) return 'live';
    return 'future';
};
const date_getLiveState = getLiveState;
export default date_getLiveState;
